import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface HubUIState {
    collapsedSections: Record<string, boolean>;
    toggleSection: (id: string) => void;
}

/**
 * useHubUIStore: Persists the expanded/collapsed state of Metabolic Hub sections.
 */
export const useHubUIStore = create<HubUIState>()(
    persist(
        (set) => ({
            collapsedSections: {},
            toggleSection: (id) => set((state) => ({
                collapsedSections: {
                    ...state.collapsedSections,
                    [id]: !state.collapsedSections[id]
                }
            })),
        }),
        { name: 'mp-hub-ui-state' }
    )
);
